import React, { Fragment } from "react"
import PropTypes from "prop-types"
import styled from "react-emotion"
import { withRouter, Link } from "react-router"

import Icon from "ui/legacy/Icon"

class SidebarSection extends React.Component {
    render() {
        const thisRoute = this.props.router.routes[this.props.router.routes.length - 1]
        const isSectionSelected = thisRoute.section === this.props.name
        return (
            <Fragment>
                {/* <Link to={"/" + this.props.url}>
                    <SectionButton active={isSectionSelected}>
                        <SectionIcon name={this.props.icon} />
                        <ButtonLabel>{this.props.name} </ButtonLabel> <Arrow />
                    </SectionButton>
                </Link> */}
                <SectionMenu open={true || isSectionSelected}>{this.props.children}</SectionMenu>
            </Fragment>
        )
    }
}

SidebarSection.propTypes = {
    children: PropTypes.node,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
}

const SectionIcon = styled(Icon)`
    vertical-align: middle;
    display: inline-block;
    height: 30px;
    width: 30px;
    line-height: 76px;
    margin: 23px 0px;
`

const Arrow = styled("div")`
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #f9f9f9;
    position: relative;
    left: 170px;
    top: -47px;
`

const SectionButton = styled("div")`
    font-family: "Avenir-Next";
    background: ${props => (props.active ? "#D68705" : "")};
    color: ${props => (props.active ? "white" : "#ccc")};
    height: 76px;
    padding: 0px 20px;
    &:hover {
        background: ${props => (props.active ? "#D68705" : "#21262d")};
    }

    ${SectionIcon} {
        filter: invert(${props => (props.active ? "100" : "50")}%);
    }

    ${Arrow} {
        display: ${props => (props.active ? "" : "none")};
    }
`
const SectionMenu = styled("div")`
    font-family: "Avenir-Next";
    height: ${props => (props.open ? "auto" : "0px")};
    transition: height 0.3s ease-out;
    overflow: hidden;
    color: grey;
    background: #252a31;
    padding: 0px 0px ${props => (props.open ? "0px" : "0px")} 0px;

    &:first-child {
        border-top: 1px solid #3e4650;
    }

    &:last-child {
        padding-bottom: 30px;
        border-bottom: 1px solid #3e4650;
    }
`
const ButtonLabel = styled("span")`
    padding: 10px;
    vertical-align: middle;
    font-weight: bold;
    text-decoration: none !important;
    text-transform: uppercase;
    letter-spacing: 2pt;
    font-size: 8pt;
`

export default withRouter(SidebarSection)



// WEBPACK FOOTER //
// ./src/features/studio/components/SidebarSection.js